module.exports = __webpack_public_path__ + "58cdb7842d36efcadf8cb78d4110e935.jpg";